import { entryRoutes } from '../../../utility/route-locations';

// Menu - Credits
const creditsMenuStructure = {
  groups: [{
    name: 'only_one',
    titleId: 'n/a',
    items: [
      {
        name: 'view-bal',
        titleId: 'viewCredits',
        path: 'todo4',
        hidden: true,
      },
      {
        name: 'buy-credits',
        titleId: 'purchaseInspections',
        path: entryRoutes.purchaseCredits,
      },
      {
        name: 'credit-history',
        titleId: 'purchaseHistory',
        path: entryRoutes.purchaseHistory,
      },
      {
        name: 'credit-usage',
        titleId: 'creditUtilisation',
        path: entryRoutes.creditUsage,
      },
    ],
  }],
};

export default creditsMenuStructure;
